import React, { useEffect, useState, useRef } from 'react'
import apiClient from '../../utils/api/apiClient'
import { APIEndpoints } from '../../utils/api/apiConfig'
import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import ArraySelect from '../Select/ArraySelect'
import { useObserver } from 'mobx-react'
import { emptyGuid, isEmptyGuid } from '../../utils/emptyGuid'
import { t } from 'i18next'

const StyledWrapper = styled.div`


  .form-group {
    padding-left:20px;

    @media screen and (min-width: 460px) {
      width: auto;
    }
  }
`

const OrderProcessTypeFilter = ({ orderProcessTypeFilter, setOrderProcessTypeFilter}) => {
  const [orderProcessTypes, setOrderProcessTypes] = useState([])
  let orderProcessTypeId = useObserver(() => orderProcessTypeFilter?.orderProcessTypeId || emptyGuid)
  const mountedRef = useRef(true)

  useEffect(() => {
    apiClient.getJson(APIEndpoints.orderProcessTypes).then(resp => {
      if (!mountedRef.current) return null
      setOrderProcessTypes(resp)
    })
    return () => {
      mountedRef.current = false
    }
  }, [])

  const updateOrderProcessTypeFilter = (displayName, orderProcessTypeId = emptyGuid) => {
    let newObj = {
      displayName,
      orderProcessTypeId,
    }
    setOrderProcessTypeFilter(newObj)
  }

  const handleChange = e => {
    let newOrderProcessTypeId = e.target.value

    if (!isEmptyGuid(newOrderProcessTypeId)) {
        const orderProcessTypeDisplayName = orderProcessTypes.find((obj) => obj.id === newOrderProcessTypeId).displayName
        updateOrderProcessTypeFilter(orderProcessTypeDisplayName, newOrderProcessTypeId)
    }
    else {
        updateOrderProcessTypeFilter(null)
    }
  }

  return (
    <StyledWrapper>
      <div>
        <Form.Group className="mb-3">
          <ArraySelect
            options={orderProcessTypes}
            value={orderProcessTypeId}
            onChange={handleChange}
            defaultOption={{ value: emptyGuid, name: t('employeesPage:filterNotSelected') }}
            returnEvent
          />
        </Form.Group>
      </div>
    </StyledWrapper>
  )
}

export default OrderProcessTypeFilter